import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

import {hooks} from '../hooks';
import {custom} from '../custom';
import {svg} from '../assets/svg';
import {components} from '../components';
import {utils} from '../utils';

import { User, Phone, Mail, Calendar, MapPin } from 'lucide-react'; // Importando os ícones do Lucide
import { theme } from '../constants';

import Https from '../utils/apiUtility';


// Interface para o assinante
interface SubscriberType {
  nome: string;
  avatar: string;
  telefone: string;
  email: string;
  nascimento: string;
  endereco: string;
}

// Função para formatar a data de nascimento
const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return "DD/MM/AAAA"; // Retorna o placeholder caso a data seja indefinida
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

// Função para extrair as iniciais do nome
const getInitials = (name: string): string => {
  const words = name.split(" ");
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase();
};

export const EditPersonalInfo: React.FC = () => {
  const {pathname} = useLocation();
  const navigate = hooks.useAppNavigate();
  const [subscriber, setSubscriber] = useState<SubscriberType | null>(null);

  useEffect(() => {
    setTimeout(() => {
      window.scroll({top: -1, left: 0, behavior: 'smooth'});
    }, 10);
  }, [pathname]);

  useEffect(() => {
    const fetchSubscriber = async () => {
      try {
        const response = await Https.get("/assinante");
        setSubscriber(response.data);
      } catch (error) {
        console.error("Erro ao buscar assinante:", error);
      }
    };

    fetchSubscriber();
  }, []);

  const renderBackground = (): JSX.Element => {
    return <components.Background />;
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='Editar informações pessoais'
        goBack={true}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main
        className='container'
        style={{marginTop: 52 + 10, marginBottom: 20}}
      >
        <div
          style={{
            width: 70,
            height: 70,
            margin: '0 auto',
            marginBottom: 30,
            cursor: 'pointer',
            userSelect: 'none',
            position: 'relative',
            ...utils.flexCenter(),
          }}
        >
          <img
            alt="avatar"
            src={subscriber?.avatar ?? `https://placehold.co/400?text=${getInitials(subscriber?.nome ?? "A")}&font=roboto`}
            style={{
              width: '100%',
              height: '100%',
              borderRadius: 50,
              position: 'absolute',
            }}
          />
          <div
            style={{
              inset: 0,
              borderRadius: 50,
              backgroundColor: 'rgba(27, 29, 77, 0.5)',
              position: 'absolute',
            }}
          />
          <svg.CameraSvg style={{zIndex: 3}} />
        </div>

        <custom.InputField
          leftIcon={
            <div
              style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <User size={20} color={theme.colors.mainDark} />
            </div>
          }
          placeholder={subscriber?.nome || "Digite seu nome"}
          containerStyle={{ marginBottom: 10 }}
        />

        <custom.InputField
          leftIcon={
            <div
              style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Phone size={20} color={theme.colors.mainDark} />
            </div>
          }
          placeholder={subscriber?.telefone || "Digite seu telefone"}
          containerStyle={{ marginBottom: 10 }}
        />

        <custom.InputField
          leftIcon={
            <div
              style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Mail size={20} color={theme.colors.mainDark} />
            </div>
          }
          placeholder={subscriber?.email || "Digite seu e-mail"}
          containerStyle={{ marginBottom: 10 }}
        />

        <custom.InputField
          leftIcon={
            <div
              style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Calendar size={20} color={theme.colors.mainDark} />
            </div>
          }
          placeholder={formatDate(subscriber?.nascimento)}
          containerStyle={{ marginBottom: 10 }}
        />

        <custom.InputField
          leftIcon={
            <div
              style={{
                padding: 8,
                backgroundColor: theme.colors.lightGrey,
                borderRadius: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <MapPin size={20} color={theme.colors.mainDark} />
            </div>
          }
          placeholder={subscriber?.endereco || "Digite seu endereço"}
          containerStyle={{ marginBottom: 14 }}
        />

        <components.Button
          title='Salvar'
          onClick={() => navigate(-1)}
        />
      </main>
    );
  };

  return (
    <div id='screen'>
      {renderBackground()}
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
